/** Source quality annotation, never an invented classification or verified identity. */
export interface ChecklistUnresolvedClassification {
  status: 'UNRESOLVED';
  scope: 'subset-or-parallel';
  sourceSubsetId: string;
  sourceLabel: string;
  sourceNotes?: string;
}

/** Exact published Synthetic Blood is a real parallel, not an unresolved marker. */
export function isChecklistPlaceholderLabel(value: unknown): boolean {
  return (
    typeof value === 'string' &&
    !/^\s*synthetic blood\s*$/i.test(value) &&
    /synthetic|pending sourcing|unresolved placeholder/i.test(value)
  );
}

export function checklistUnresolvedClassification(
  row: { sourceSubsetId: string; subset: string; parallelName?: string; notes?: string },
  definitions: readonly {
    name: string;
    sourceSubsetId?: string;
    source?: { subsetId: string };
    notes?: string;
  }[],
): ChecklistUnresolvedClassification | undefined {
  const definition = definitions.find(
    (candidate) =>
      (candidate.sourceSubsetId ?? candidate.source?.subsetId) === row.sourceSubsetId &&
      isChecklistPlaceholderLabel(candidate.name),
  );
  const label =
    definition?.name ?? [row.subset, row.parallelName].find(isChecklistPlaceholderLabel);
  if (label === undefined) return undefined;
  const notes = definition?.notes ?? row.notes;
  return {
    status: 'UNRESOLVED',
    scope: 'subset-or-parallel',
    sourceSubsetId: row.sourceSubsetId,
    sourceLabel: label,
    ...(notes === undefined ? {} : { sourceNotes: notes }),
  };
}
